import { ReactNode } from 'react';
import Container from '../container';
import BackofficeSidebar from '../BackofficeSidebar';
import SogaSidebar from '../SogaSidebar/SogaSidebar';
import GeneralContainerView from '../generalContainerView';
import Header from '../header/Header';
import ModuleView from '../moduleView';
import useOnlyDevelopers from '../../state/setOnlyDevelopers';

interface IButton {
  title?: string;
  route?: string;
  color?: string;
  icon?: ReactNode;
  action?: () => void;
  identifiacator?: string;
}

interface IHeaderInfo {
  title: string;
  subtitle: string;
  titleRoute?: string;
  searchbarPlaceholder?: string;
}

interface ISideBar {
  position: string;
}
interface ISharedModules {
  title: string;
  key: number;
  active: boolean;
}

interface IButtons {
  buttons?: IButton[];
  children: ReactNode;
  headerInfo?: IHeaderInfo;
  infoSideBar?: ISideBar;
  viewSearchBar?: boolean;
  searchBarDropdownList?: JSX.Element;
  searchText?: string;
  searchbarPlaceholder?: string;
  setSearchText?: (text: string) => void;
  buttonDisabled?: boolean;
  sharedModules?: ISharedModules[];
  sharedModule?: ISharedModules;
  sharedModulesAction?: (key: number) => void;
  loadingSearchBar?: boolean;
  customClassNameButtonMenu?: string;
  custonMarginRightButtonsContainer?: string;
  customClassNameModuleView?: string;
}

/**
 * Componente principal que renderiza el layout del módulo con header, sidebar y contenido
 * Utiliza Sidebar con cambios del PR si onlyDevelopers está activo, de lo contrario usa BackofficeSidebar
 */
const ChargerModule = ({
  children,
  buttons,
  headerInfo,
  infoSideBar,
  viewSearchBar,
  searchBarDropdownList,
  searchText,
  searchbarPlaceholder,
  setSearchText,
  buttonDisabled,
  sharedModules,
  sharedModule,
  sharedModulesAction,
  loadingSearchBar,
  customClassNameButtonMenu = '',
  custonMarginRightButtonsContainer = '',
  customClassNameModuleView = ''
}: IButtons) => {
  const { onlyDevelopers } = useOnlyDevelopers();

  return (
    <Container>
      <Header
        buttonsHeader={buttons}
        headerInfo={headerInfo}
        viewSearchBar={viewSearchBar}
        searchBarDropdownList={searchBarDropdownList}
        searchbarPlaceholder={searchbarPlaceholder}
        searchText={searchText}
        setSearchText={setSearchText}
        buttonDisabled={buttonDisabled}
        sharedModules={sharedModules}
        sharedModulesAction={sharedModulesAction}
        sharedModule={sharedModule}
        loadingSearchBar={loadingSearchBar}
        customClassNameButtonMenu={customClassNameButtonMenu}
        custonMarginRightButtonsContainer={custonMarginRightButtonsContainer}
      />
      <GeneralContainerView>
        {onlyDevelopers ? (
          <SogaSidebar infoSideBar={infoSideBar} />
        ) : (
          <BackofficeSidebar infoSideBar={infoSideBar} />
        )}
        <ModuleView className={customClassNameModuleView}>{children}</ModuleView>
      </GeneralContainerView>
    </Container>
  );
};

export default ChargerModule;
